// extracted by mini-css-extract-plugin
export default {"image_container":"Home_image_container__FAzwA","wallpaper":"Home_wallpaper__tJGhW","text":"Home_text__UcC7E","textP":"Home_textP__IrGtn","paul":"Home_paul__BPmxk"};